<template>
  <div class="uploadCode-wrapper">
    <div class="upload-content">
      <div class="config-wrapper">
        <button class="addAttBtn" @click="addAttr">
          添加属性
        </button>
        <div class="att-list-wrapper">
          <div v-for="(item, index) in listData" :key="index" class="att-item">
            <span class="item-title">{{ item.name }}</span>
            <textarea v-model="item.value" rows="1" cols="40" class="item-value">a</textarea>
            <button @click="openConfig">
              修改
            </button>
          </div>
        </div>
      </div>
      <div class="code-preview-wrapper">
        <!-- code-preview -->
        <textarea class="code" rows="5" cols="33">a</textarea>
      </div>
    </div>
    <configDialog ref="config" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      listData: [
        {
          id: '1',
          name: 'name1',
          value: 'value1',
        },
      ],
    };
  },
  components: {
    configDialog: () => import('./dialog/configDialog.vue'),
  },
  methods: {
    openConfig() {
      this.$refs.config.open();
    },
    addAttr() {
      const data = {
        name: 'name',
        value: 'value'
      };
      this.listData.push(data);
    }
  },
};
</script>

<style lang="less" scoped>
.uploadCode-wrapper {
  padding-top: 50px;
  width: 100%;
  height: 100%;
  .upload-content {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    .config-wrapper {
      width: 45%;
      text-align: center;
      .addAttBtn {
        padding: 6px 20px;
        border: 1px solid #fff;
      }
      .att-list-wrapper {
        width: 100%;
        .att-item {
          margin-top: 20px;
          width: 100%;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          justify-content: space-between;
          align-items: flex-end;
          .item-title {
            font-size: 16px;
            margin-right: 16px;
          }
          .item-value {
            background-color: transparent;
            border-bottom: 1px solid #fff;
            border-radius: 2px;
            padding: 10px;
            outline: none;
            font-size: 12px;
          }
        }
      }
    }
    .code-preview-wrapper {
      width: 45%;
      .code {
        width: 100%;
        height: 400px;
        background-color: transparent;
        outline: none;
        border: 1px solid rgba(255, 255, 255, 0.8);
        padding: 10px;
        border-radius: 4px;
      }
    }
  }
}
</style>